import script from "./technician_report.vue?vue&type=script&setup=true&lang=js"
export * from "./technician_report.vue?vue&type=script&setup=true&lang=js"

import "./technician_report.vue?vue&type=style&index=0&id=25268eac&lang=css"

const __exports__ = script;

export default __exports__